<p-iconfield [formGroup]="form">
  @if (!isReadOnly()) {
    <p-inputmask
      type="text"
      [hidden]="isReadOnly()"
      [mask]="maskPlaceholder()"
      [autoClear]="false"
      [autofocus]="focusToEdit()"
      [class]="cssClass()"
      [class.ng-invalid]="!isValid()"
      [class.ng-dirty]="form.get('control')?.dirty"
      [inputId]="id()"
      formControlName="control"
      [styleClass]="styleClass()"
      (onBlur)="toggleState()"
      data-testid="agility-toggle-mask-input"
    ></p-inputmask>
  }
  @if (isReadOnly()) {
    <input
      pInputText
      type="text"
      [value]="maskedValue()"
      [disabled]="true"
      data-testid="agility-toggle-mask-readonly-input"
    />
  }
  @if (form.get('control')?.value) {
    <p-inputicon
      class="pi"
      [styleClass]="toggleIconStyleClass()"
      (click)="onToggleMaskClick()"
      [pTooltip]="permissionService.tooltip"
      [tooltipDisabled]="viewSensitiveLoanData"
      tooltipPosition="right"
      data-testid="agility-toggle-mask-icon"
    />
  }
</p-iconfield>
